import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from "@mui/material";
import { WRAPPER_OPTIONS, WRAPPER_PAIRS } from "../utils/DefaultConfigWitness";
export const WrapperSelector = ({ wrapperStart, onWrapperChange }) => (
  <FormControl size="small" fullWidth>
    <InputLabel id="wrapper-label">Envoltorio</InputLabel>
    <Select
      labelId="wrapper-label"
      id="wrapper-select"
      value={wrapperStart}
      label="Envoltorio"
      onChange={(e) => {
        const start = e.target.value;
        const end = WRAPPER_PAIRS[start] ?? "";
        onWrapperChange(start, end);
      }}
    >
      {WRAPPER_OPTIONS.map((opt) => (
        <MenuItem key={opt.value} value={opt.value}>
          {opt.label}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);